export const usePreview = () => {
    const route = useRoute()
    const isPreview = computed(() => {
        const previewQuery = route.query.preview === 'true'
        const previewCookie = useCookie('contentful-preview').value === 'true'
        return previewQuery || previewCookie
    })

    return {
        isPreview
    }
};
